import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { fetchReports } from '../../../actions/roblox/reportsActions';
import { queryParams } from "../../../helpers/UrlHelpers";

import PageHeader from "../../../componets/PageHeader";
import PageLayout from '../_partials/PageLayout';
import List from "./_partials/_List";

const LIMIT = 50;

const Reports: React.FC = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const { pathname }    = useLocation();

  useEffect(() => {
    const params: any = {
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT
    };

    dispatch(fetchReports(params));
  }, [currentPage, pathname, dispatch]);

  return (
    <PageLayout>
      <PageHeader title={'Reports'} />

      <div className='v-container-fluid'>
        <List limit={LIMIT} />
      </div>
    </PageLayout>
  );
}

export default Reports;
